import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import UserProfile from '../auth/UserProfile';
import logo from '../../assets/images/logo.png';

const TAB_BASE: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '10px 22px',
  borderRadius: '8px 8px 0 0',
  fontSize: '14px',
  fontWeight: '600',
  cursor: 'pointer',
  border: 'none',
  background: 'transparent',
  transition: 'background 0.15s ease, color 0.15s ease',
  letterSpacing: '0.01em',
  marginBottom: '-2px', // sits on top of the separator line
  position: 'relative',
};

const TAB_ACTIVE: React.CSSProperties = {
  ...TAB_BASE,
  backgroundColor: 'rgba(255, 255, 255, 0.18)',
  color: 'white',
  borderBottom: '2px solid transparent',
};

const TAB_INACTIVE: React.CSSProperties = {
  ...TAB_BASE,
  backgroundColor: 'transparent',
  color: 'rgba(255, 255, 255, 0.55)',
  borderBottom: '2px solid transparent',
};

interface TopMenuShellProps {
  children?: React.ReactNode;
}

const TopMenuShell: React.FC<TopMenuShellProps> = ({ children }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isLeads = pathname === '/' || pathname === '';
  const isEvents = pathname === '/events';

  return (
    <div style={{
      background: 'linear-gradient(to right, #0ea5e9, #0369a1, #a855f7)',
      color: 'white',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
    }}>
      {/* Logo + User Profile */}
      <div className="container" style={{ padding: '20px 24px 0 24px', position: 'relative' }}>
        <div style={{ position: 'absolute', top: '16px', right: '24px', zIndex: 10 }}>
          <UserProfile />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
          <img src={logo} alt="Modulai Logo" style={{ height: '40px', width: 'auto' }} />
        </div>
      </div>

      {/* Tab bar — separator starts from tab content */}
      <div className="container" style={{ padding: '0 24px' }}>
        <div style={{ display: 'flex', gap: '2px', alignItems: 'flex-end', borderBottom: '2px solid rgba(255, 255, 255, 0.2)' }}>
          <button style={isLeads ? TAB_ACTIVE : TAB_INACTIVE} onClick={() => navigate('/')}>
            <svg width="15" height="15" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
            </svg>
            Leads
          </button>

          <button style={isEvents ? TAB_ACTIVE : TAB_INACTIVE} onClick={() => navigate('/events')}>
            <svg width="15" height="15" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            Events
          </button>
        </div>
      </div>

      {/* Page-specific content (stats, filters, nav, search) */}
      {children && (
        <div className="container" style={{ padding: '0 24px 14px 24px' }}>
          {children}
        </div>
      )}
    </div>
  );
};

export default TopMenuShell;
